import { CircleDecorator } from './CustomDecorators/CircleDecorator';
import { HalfStadiumDecorator } from './CustomDecorators/HalfStadiumDecorator';
import { QuadrantDecorator } from './CustomDecorators/QuadrantDecorator';

export const decorators = {
  circle: CircleDecorator,
  halfStadium: HalfStadiumDecorator,
  quadrant: QuadrantDecorator,
};

export type Decorator = keyof typeof decorators;
